"use client";

import React from "react";
import { StockCard } from "./StockCard";
import type { StockSectionProps } from "./types";
import { cn } from "utils";
import { useGoToDetail } from "@/src/hooks/useGoToDetail";

/**
 * 股票区块组件 - 用于显示股票/加密货币列表
 */
export const StockSection: React.FC<StockSectionProps> = ({
  title,
  stocks,
  viewAllText = "View all",
  onViewAll,
  className,
  showAll = false,
  type,
  onClose,
  originType,
}) => {
  const { onDetail } = useGoToDetail(type || "stock");
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      {title && (
        <h3
          aria-label="Stock Section h3"
          data-openreplay-label="home_stocksection_h3"
          id="sem-stock-section-h3"
          className="title_s text-content_tertiary"
        >
          {title}
        </h3>
      )}
      <div className="flex flex-col gap-0">
        {(showAll ? stocks : stocks.slice(0, 4)).map((stock, index) => (
          <StockCard
            data-openreplay-label="home_stocksection_stockcard"
            key={stock.id || `${stock.symbol}-${index}`}
            data={stock}
            originType={originType}
            onClick={() => {
              onDetail(stock);
              onClose?.();
            }}
          />
        ))}
        {onViewAll && (
          <button
            aria-label="Stock Section"
            data-openreplay-label="home_stocksection_click"
            id="btn-stock-section"
            className="body_medium_s text-content_brand_primary text-center cursor-pointer hover:opacity-80 transition-opacity w-fit"
            onClick={onViewAll}
          >
            {viewAllText}
          </button>
        )}
      </div>
    </div>
  );
};
